import {Link as RoutedLink} from 'react-router-dom';

import {ButtonGroup} from 'shells/button-group/button-group';
import {CogRegularIcon} from 'shells/icon/svg/cog-regular-icon';
import {Link} from 'shells/link/link';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {ForwardingStatusButton} from './forwarding-status-button/forwarding-status-button';

export function EmailHeaderButtons() {
    const {user} = useGetSessionUser();
    const userCanAccessSetup = Boolean(user && user.permissions.canAccessSetup);

    if (!userCanAccessSetup) {
        return null;
    }

    return (
        <ButtonGroup>
            <ForwardingStatusButton />
            <Link
                // @ts-expect-error
                as={RoutedLink}
                icon={CogRegularIcon}
                to='/inbox/settings/email'
                size='big'
                variant='button-secondary'
            >
                Inbox settings
            </Link>
        </ButtonGroup>
    );
}
